module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAE9JREFUSA1jYBgFoyGAHAL/oQBZjBCbiZACSuVHLSAYgjQPIkZsTgAlFmzihMQYgQBdDc19gG4hXv5oPsAbPORK0jySaW4BuT4f1TeEQgAAYYoUCIMHViwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/White/Add.png
// module id = 655
// module chunks = 0